const BOT_USERNAME = 'sabad1_shop_bot';

const config = {
    env: process.env.NODE_ENV || 'development',

    // api: {
    //     baseURL: 'https://api-app.liara.run/api/v1/',
    //     rootURL: 'https://api-app.liara.run',
    //     fontUrl: 'https://sabad1.shop/',
    //     LinkApp: 'https://sabad1.shop/',
    //     imageURL: 'https://main-app.hot.ir-central1.arvanstorage.ir',
    //     timeout: 10000,
    // },
    
    api: {
        baseURL: 'https://api.sabad1.com/api/v1/',
        rootURL: 'https://api.sabad1.com',
        fontUrl: 'https://sabad1.shop/',
        LinkApp: 'https://sabad1.shop/', //لینک کالا و فروشگاه از روی ایسنتاگرام
        imageURL: 'https://main-app.hot.ir-central1.arvanstorage.ir',
        timeout: 10000,
    },

    // api: {
    //     baseURL: 'http://178.131.87.248:4090/api/v1/',
    //     rootURL: 'http://178.131.87.248:4090',
    //     fontUrl: 'https://rabet24.shop/',
    //     timeout: 10000,
    // },
    // api: {
    //     baseURL: 'http://192.168.1.200/api/v1/',
    //     rootURL: 'http://192.168.1.200',
    //     fontUrl: 'https://rabet24.shop/',
    //     timeout: 10000,
    // },
    app: {
        name: 'Sabad1 MiniApp',
        version: '1.0.0',
        botUsername: BOT_USERNAME,
    },

    // کلیدهای start_param تلگرام (همان مقادیری که در لاراول تعریف شده‌اند)
    telegram_actions: {
        // اعلان‌های فروشنده
        SELLER_NEW_ORDER: 'seller_new_order',
        SELLER_CHAT: 'seller_chat',
        SELLER_REPORT: 'seller_report',
        BUYER_ACCEPT_COLLABORATION: 'buyer_accept_collaboration',
        BUYER_CANCEL_COLLABORATION: 'buyer_cancel_collaboration',
        SELLER_SUPPORT: 'seller_support',
        SELLER_TRACKING_POST: 'seller_tracking_post',

        // اعلان‌های خریدار
        BUYER_CANCEL_INVOICE: 'buyer_cancel_invoice',
        BUYER_CONFIRM_INVOICE: 'buyer_confirm_invoice',
        BUYER_CHAT: 'buyer_chat',
        BUYER_REPORT: 'buyer_report',
        SELLER_REQUEST_COLLABORATION: 'seller_request_collaboration',
        BUYER_SUPPORT: 'buyer_support',

        // موارد عمومی قبلی
        WELCOME: 'welcome',
        REPORTS: 'reports',
        REPORT: 'report',
        CANCEL_ORDER: 'cancelorder'
    },

    // نگاشت start_param به روت‌ها و state مقصد در مینی‌اپ
    notification_redirects: {
        // مسیرهای مربوط به پنل فروشنده
        'seller_new_order': { to: '/StorePanelStation', state: { tab: 'orders', startParam: 'seller_new_order' } },
        'seller_chat': { to: '/Report', state: { tab: 'chat', startParam: 'seller_chat' } },
        'seller_report': { to: '/Report', state: { tab: 'reports', startParam: 'seller_report' } },
        'seller_support': { to: '/StorePanelStation', state: { tab: 'support', startParam: 'seller_support' } },
        'seller_tracking_post': { to: '/Report', state: { tab: 'shipping', startParam: 'seller_tracking_post' } },
        'seller_request_collaboration': { to: '/HomePage', state: { tab: 'collab_requests', startParam: 'seller_request_collaboration' } },

        // مسیرهای مربوط به خریدار
        'buyer_accept_collaboration': { to: '/StorePanelStation', state: { startParam: 'buyer_accept_collaboration' } },
        'buyer_cancel_collaboration': { to: '/StorePanelStation', state: { startParam: 'buyer_cancel_collaboration' } },
        'buyer_cancel_invoice': { to: '/Report', state: { tab: 'invoices', startParam: 'buyer_cancel_invoice' } },
        'buyer_confirm_invoice': { to: '/Report', state: { tab: 'invoices', startParam: 'buyer_confirm_invoice' } },
        'buyer_chat': { to: '/StorePanelStation', state: { tab: 'chat', startParam: 'buyer_chat' } },
        'buyer_report': { to: '/StorePanelStation', state: { tab: 'reports', startParam: 'buyer_report' } },
        'buyer_support': { to: '/HomePage', state: { tab: 'support', startParam: 'buyer_support' } },

        // سازگاری با موارد گذشته
        'welcome': { to: '/HomePage', state: { startParam: 'welcome' } }
    },

    // تابع کمکی برای ساخت سریع لینک باز شدن بات در تلگرام
    getTelegramLink: (actionParam) => {
        return `https://t.me/${BOT_USERNAME}?startapp=${actionParam}`;
    }
};

export default config;
